import { render } from "./QuestionSelect.vue?vue&type=template&id=3e6f6556&ts=true"
import script from "./QuestionSelect.vue?vue&type=script&lang=ts"
export * from "./QuestionSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__